import { useCallback, useEffect, useMemo, useState } from 'react';
import cookie from 'react-cookies';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { EMediaWidth } from '@r1-frontend/ui-react/tokens/mediaWidth';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { MobileAppPopupAnalytics } from '~/src/components/MobileAppPopup/MobileAppPopup.analytics';
import { MobileAppPopupComponent } from '~/src/components/MobileAppPopup/MobileAppPopupComponent';
import { AUTH_SOURCE_COOKIE, DEFAULT_COOKIES_CONFIG } from '~/src/constants';
import { selectHasAuthorization } from '~/src/store/selectors/auth/selectAccessToken';

const MOBILE_LINK = 'https://app.dom.ru/popup';
export const MOBILE_APP_POPUP_COOKIE = 'mobile_app';

export const MobileAppPopup = () => {
    const router = useRouter();

    const hasMobileAppCookie = useMemo(() => cookie.load(MOBILE_APP_POPUP_COOKIE), []);
    const hasSourceWebCookie = useMemo(() => cookie.load(AUTH_SOURCE_COOKIE) === 'web', []);

    const isMobile = useMatchMedia(EMediaWidth.mobile, true);
    const hasAuthorization = useSelector(selectHasAuthorization);

    // Состояние, которое показывает, будет ли показан попап.
    // Когда условия для показа попапа выполняются, оно становится isShowPopup = true
    const [isShowPopup, setIsShowPopup] = useState(
        hasSourceWebCookie && hasAuthorization && !hasMobileAppCookie,
    );

    useEffect(() => {
        if (isShowPopup && isMobile) {
            MobileAppPopupAnalytics.show();
        }
    }, [isShowPopup, isMobile]);

    const closeHandler = useCallback((value) => {
        setIsShowPopup(false);
        cookie.save(MOBILE_APP_POPUP_COOKIE, value, {
            ...DEFAULT_COOKIES_CONFIG,
            expires: undefined, // сессия
            maxAge: undefined,
        });
    }, [setIsShowPopup]);

    const onAgreement = useCallback(() => {
        router.push(MOBILE_LINK);
        MobileAppPopupAnalytics.download();
        closeHandler('visited');
    }, [closeHandler, router]);

    const onClose = useCallback(() => {
        closeHandler('closed');
    }, [closeHandler]);

    return (
        <MobileAppPopupComponent
            isOpen={isMobile && isShowPopup}
            onAgreement={onAgreement}
            onClosePopup={onClose}
        />
    );
};
